export const API_BASE_URL = '/api';

export const API_SECRET_KEY = '052053fdbbbc937a696e467cdaed029f1e51066e9065e8f58a179a5e8191fe07';

export const CONFIG = {
  CHECK_DUPLICATE_CODES: false,
};

export const STORAGE_KEYS = {
  SINGLE_TASK: 'taskProcessor_singleTask',
  BATCH_TASK: 'taskProcessor_batchTask',
  FAILED_TASKS: 'taskProcessor_failedTasks',
  SUCCESS_RECORDS: 'taskProcessor_successRecords'
};

export const TASK_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  TIMEOUT: 'timeout'
};

export const RETRY_CONFIG = {
  MAX_RETRIES: 3,
  RETRY_DELAY: 2000,
  POLL_INTERVAL: 3000,
  MAX_POLL_RETRIES: 80
};